import React, { Component } from "react";
import { Modal, Form, Input, Row, Spin } from "antd";
import { observer } from "mobx-react";

const { TextArea } = Input;

const FormItem = Form.Item;

@Form.create({})
@observer
class AddProxiesDialog extends Component {
	addProxies = () => {
		this.props.form.validateFields((err, changedFields) => {
			if (err) {
				return;
			}
      let proxies = this.props.form.getFieldValue("proxies");
      this.props.addProxies(proxies);
      this.props.form.resetFields();      
		});
	};

	hideDialog = () => {
		this.props.form.resetFields();
		this.props.hideDialog();
	};

	render() {
		const {
			ui: { addProxiesDialogVisible, addingProxies },
			hideDialog,
			form
		} = this.props;
		return (
			<Modal
				visible={addProxiesDialogVisible}
				title="Add New Proxies"
				okText="Add"
				onCancel={this.hideDialog}
				onOk={this.addProxies}
			>
				<Spin spinning={addingProxies == true}>
					<Form layout="vertical">
						<FormItem label="Proxies">
							<span style={{ fontSize: 12 }}>
								Proxies are in this format: <b>ip:port:username:password</b> or{" "}
								<b>ip:port</b>
							</span>
							{form.getFieldDecorator("proxies", {
								rules: [
									{
										required: true,
										message: "Please enter proxies"
									}
								]
							})(<TextArea style={{ height: 200 }} />)}
						</FormItem>
					</Form>
				</Spin>
			</Modal>
		);
	}
}

export default AddProxiesDialog;
